import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';

import {
  Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography, Select, InputLabel, Checkbox, ListItemText, OutlinedInput, Box, Grid
} from '@material-ui/core';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditItemView from './EditItemView';
import EditAttributesView from './attributes/EditAttributesView';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';
import { Divider } from '@mui/material';

import { useTranslation } from './LocalizationProvider';
import useGeofenceAttributes from './attributes/useGeofenceAttributes';
import { useSelector } from 'react-redux';
import { api_call, console_log } from './helpers/untils';
import { Stack } from '@mui/material';
import { useLocation } from "react-router-dom"
import ConfirmDialog from './components/ConfirmDialog';
import { APP_NAME, MACHINE_ENVIRONMENT, NOTIFICATION_SOUND_LIST } from './config/constant';

const GEOFENCE_DEFAULT_ENTER_SUBJECT = '{{Car_Name}} has entered {{Fence_Name}}'
const GEOFENCE_DEFAULT_LEAVE_SUBJECT = '{{Car_Name}} has left {{Fence_Name}}'

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'column',
  },
}));

const GeofencePage = () => {
  const classes = useStyles();
  const t = useTranslation();
  const user = useSelector((state) => state.session.user);

  const [item, setItem] = useState({ notify_email_enter: user.email, notify_email_leave: user.email, deviceIds: [] });

  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const q = params.get("q")

  const parseQueryParam = (q) => {
    try {
      if (item?.id) {
        return {}
      } else {
        const queryParamStr = decodeURIComponent(q)
        const queryParamObj = JSON.parse(queryParamStr)
        console.log(`queryParamObj:::::::`, queryParamObj)
        if (queryParamObj) {
          return queryParamObj
        } else {
          return {}
        }
      }
    } catch (e) {
      console.log(`parseQueryParam error::::`, e)
      return {}
    }
  }

  const [enterEmailNotify, setEnterEmailNotify] = useState(false)
  const [enterPushNotify, setEnterPushNotify] = useState(false)
  const [leaveEmailNotify, setLeaveEmailNotify] = useState(false)
  const [leavePushNotify, setLeavePushNotify] = useState(false)

  ////////////////////////////////////////////////////////////////////////////
  const defaultLockMinutes = 10
  const defaultHornMinutes = 0
  const defaultKillMinutes = 0
  const defaultNextActionData = {
    enter_lock_checked: 0,
    enter_lock_miutes: defaultLockMinutes,
    enter_horn_checked: 0,
    enter_horn_miutes: defaultHornMinutes,
    enter_kill_checked: 0,
    enter_kill_miutes: defaultKillMinutes,
    leave_lock_checked: 0,
    leave_lock_miutes: defaultLockMinutes,
    leave_horn_checked: 0,
    leave_horn_miutes: defaultHornMinutes,
    leave_kill_checked: 0,
    leave_kill_miutes: defaultKillMinutes,
  }
  const [nextActionData, setNextActionData] = useState(defaultNextActionData)
  ////////////////////////////////////////////////////////////////////////////

  const [devices, setDevices] = useState([]);

  const getDeviceNameFromId = (deviceId) => {
    //console.log("devices::::", devices)
    for (const key in devices) {
      if (devices.hasOwnProperty(key) && devices[key].id === deviceId) {
        return devices[key].name;
      }
    }
    return ""
  }

  const onChangeSelectedDevices = async (deviceIds) => {
    let currentdeviceIds = [...deviceIds];
    const totalDeviceIds = devices.map((item) => item.id);
    console.log(`onChangeSelectedDevices deviceIds, totalDeviceIds::::`, deviceIds, item.deviceIds);
    const oldDeviceIds = item.deviceIds;
    const newDeviceIds = deviceIds;
    const diffPlus = newDeviceIds.filter(x => !oldDeviceIds.includes(x));
    const diffMinus = oldDeviceIds.filter(x => !newDeviceIds.includes(x));
    if (diffPlus.includes(0)) {
      currentdeviceIds = [...totalDeviceIds, 0];
    } else if (diffMinus.includes(0)) {
      currentdeviceIds = [];
    } else {
      const diffTotalMinus = totalDeviceIds.filter(x => !newDeviceIds.includes(x));
      if (diffTotalMinus.length > 0) {
        currentdeviceIds = currentdeviceIds.filter(x => x !== 0);
      } else if (diffTotalMinus.length === 0) {
        currentdeviceIds = [...currentdeviceIds, 0];
      }
    }
    setItem({ ...item, deviceIds: currentdeviceIds });
  }

  const getUserDeviceList = async () => {
    let url = '/api/device-name-list'
    const response = await api_call(url);
    if (response.ok) {
      const device_list = await response.json()
      setDevices(device_list)
    }
  }

  const [defaultValue, setDefaultValue] = useState(null)

  useEffect(() => {
    getUserDeviceList()
  }, [])

  const filter = createFilterOptions({
    stringify: (option) => option.name + "   " + option.uniqueId,
  });

  const getDefaultValue = () => {
    if (item && item?.deviceId) {
      const device_list = [...devices]
      const defaultItem = device_list.find(element => element.id === item.deviceId);
      console.log("item:::", item)
      console.log("defaultItem:::", defaultItem)
      return defaultItem
    }
    return null
  }

  useEffect(() => {
    setDefaultValue(getDefaultValue())
  }, [item, devices])

  useEffect(() => {
    if (item?.post_turo) {
      const notifyVal = item.post_turo
      if (notifyVal >= 8) {
        setEnterEmailNotify(true)
      } else {
        setEnterEmailNotify(false)
      }
      if ((notifyVal >= 4 && notifyVal < 8) || (notifyVal >= 12 && notifyVal < 16)) {
        setEnterPushNotify(true)
      } else {
        setEnterPushNotify(false)
      }
      if (notifyVal % 4 == 2 || notifyVal % 4 == 3) {
        setLeaveEmailNotify(true)
      } else {
        setLeaveEmailNotify(false)
      }
      if (notifyVal % 2 == 1) {
        setLeavePushNotify(true)
      } else {
        setLeavePushNotify(false)
      }
    }

    if (item?.id && item?.next_action_data) {
      setNextActionData(JSON.parse(item?.next_action_data))
    }
  }, [item?.id])

  useEffect(() => {
    if (item?.id && item?.deviceIds) {
      const totalDeviceIds = devices.map((item) => item.id);
      let currentdeviceIds = [...item?.deviceIds];
      const diffTotalMinus = totalDeviceIds.filter(x => !currentdeviceIds.includes(x));
      console_log(`diffTotalMinus:::::::`, totalDeviceIds, currentdeviceIds, diffTotalMinus);
      if (diffTotalMinus.length > 0) {
        currentdeviceIds = currentdeviceIds.filter(x => x !== 0);
      } else if (diffTotalMinus.length === 0) {
        currentdeviceIds = [...currentdeviceIds, 0];
      }
      setItem({ ...item, deviceIds: currentdeviceIds });
    }
  }, [item?.id, devices.length])

  const renderSelectedDeviceNames = (selectedIds) => {
    const deviceNameList = []
    if (selectedIds) {
      for (let k in selectedIds) {
        const deviceName = getDeviceNameFromId(selectedIds[k])
        if (deviceName) {
          deviceNameList.push(deviceName)
        }
      }
      return deviceNameList.join(', ')
    } else {
      return ""
    }
  }

  useEffect(() => {
    let enterE = enterEmailNotify ? "1" : "0"
    let enterP = enterPushNotify ? "1" : "0"
    let leaveE = leaveEmailNotify ? "1" : "0"
    let leaveP = leavePushNotify ? "1" : "0"
    const decimalVal = parseInt(enterE + enterP + leaveE + leaveP, 2)
    const newItemObj = {
      ...item,
      post_turo: decimalVal,
      next_action_data: JSON.stringify(nextActionData)
    }
    const queryItemObj = parseQueryParam(q)
    setItem(
      {
        ...queryItemObj,
        ...newItemObj,
        userId: user.id
      }
    )
  }, [
    enterEmailNotify,
    enterPushNotify,
    leaveEmailNotify,
    leavePushNotify,
    nextActionData,
    q
  ])

  ///////////////////////////// confirmation ///////////////////////////////////
  const [confirmAction, setConfirmAction] = useState("");
  const [confirmValue, setConfirmValue] = useState("");
  const [confirmText, setConfirmText] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const onClickAgreeConfirm = () => {
    if (confirmAction) {
      setNextActionData({ ...nextActionData, [confirmAction]: confirmValue })
      setShowConfirmModal(false);
    }
  }
  const onClickCancelConfirm = () => {
    setShowConfirmModal(false);
  }
  ///////////////////////////////////////////////////////////////////////////////

  const onChangeNextActionCheckbox = (field_name, event) => {
    const value = event.target.checked ? 1 : 0
    const confirmFields = ['enter_horn_checked', 'enter_kill_checked', 'leave_horn_checked', 'leave_kill_checked']
    const confirmTexts = {
      enter_horn_checked: "Horn will honk when this car is driving",
      leave_horn_checked: "Horn will honk when this car is driving",
      enter_kill_checked: "Killswitch will get engaged while the car is driving",
      leave_kill_checked: "Killswitch will get engaged while the car is driving"
    }
    if (confirmFields.includes(field_name) && value === 1) {
      setConfirmAction(field_name)
      setConfirmValue(value)
      setConfirmText(confirmTexts[field_name])
      setShowConfirmModal(true)
    } else {
      setNextActionData({ ...nextActionData, [field_name]: value })
    }
  }

  return (
    <EditItemView endpoint="geofences" item={item} setItem={setItem}>
      {item
        && (
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">Geofence</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <TextField
                fullWidth
                value={item.name || ''}
                onChange={(event) => setItem({ ...item, name: event.target.value })}
                label={t('sharedName')}
                variant="filled"
              />
              <FormControl margin="normal" variant="filled" fullWidth>
                <InputLabel>Device</InputLabel>
                <Select
                  fullWidth
                  multiple={true}
                  value={item.deviceIds || []}
                  onChange={(event) => onChangeSelectedDevices(event.target.value)}
                  renderValue={(selected) => renderSelectedDeviceNames(selected)}
                  disabled={devices.length === 0}
                >
                  <MenuItem key={0} value={0}>
                    <Checkbox checked={item.deviceIds.indexOf(0) > -1} />
                    <ListItemText primary={`All`} />
                  </MenuItem>

                  {devices.map((deviceItem) => (
                    <MenuItem key={deviceItem.id} value={deviceItem.id}>
                      <Checkbox checked={item.deviceIds.indexOf(deviceItem.id) > -1} />
                      <ListItemText primary={deviceItem.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Box>
                <Divider sx={{ mt: 2, mb: 1, borderBottomWidth: 4, bgcolor: '#aaaaaa' }} />
              </Box>

              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Box sx={{
                    display: 'flex',
                    mt: 2
                  }}>
                    <Checkbox
                      checked={enterEmailNotify}
                      onChange={(event) => setEnterEmailNotify(event.target.checked)}
                    />
                    <TextField
                      fullWidth
                      value={item.notify_email_enter}
                      onChange={(event) => setItem({ ...item, notify_email_enter: event.target.value })}
                      label={`Email address to notify if car enters fence:`}
                      variant="filled"
                      inputProps={{ type: 'email' }}
                      sx={{ mt: 4 }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Stack justifyContent={`flex-start`} alignItems={`center`} direction={`row`} spacing={2}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={enterPushNotify}
                        onChange={(event) => setEnterPushNotify(event.target.checked)}
                      />
                      <Typography sx={{ display: 'flex' }}>Push</Typography>
                    </Box>
                    <Select value={item.enter_push_sound || 'arrive'} onChange={(event) => setItem({ ...item, enter_push_sound: event.target.value })} variant="filled">
                      {
                        NOTIFICATION_SOUND_LIST.map((n_item) => {
                          return (
                            <MenuItem key={n_item.value} value={n_item.value}>{n_item.name}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    value={item.enter_subject || GEOFENCE_DEFAULT_ENTER_SUBJECT}
                    onChange={(event) => setItem({ ...item, enter_subject: event.target.value })}
                    label={`Subject`}
                    variant="filled"
                    inputProps={{ type: 'text' }}
                    margin="normal"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={nextActionData.enter_lock_checked}
                        onChange={(event) => onChangeNextActionCheckbox('enter_lock_checked', event)}
                      />
                      <Typography sx={{ display: 'flex' }}>Lock After</Typography>
                    </Box>
                    <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                      <TextField
                        value={nextActionData.enter_lock_miutes || ''}
                        onChange={(event) => setNextActionData({ ...nextActionData, enter_lock_miutes: event.target.value })}
                        label={``}
                        variant="filled"
                        inputProps={{ type: 'number' }}
                        style={{ mt: 0, width: '50px' }}
                      />
                      <Typography sx={{ display: 'flex' }}>Minutes</Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={nextActionData.enter_horn_checked}
                        onChange={(event) => onChangeNextActionCheckbox('enter_horn_checked', event)}
                      />
                      <Typography sx={{ display: 'flex' }}>Horn After</Typography>
                    </Box>
                    <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                      <TextField
                        value={nextActionData.enter_horn_miutes || ''}
                        onChange={(event) => setNextActionData({ ...nextActionData, enter_horn_miutes: event.target.value })}
                        label={``}
                        variant="filled"
                        inputProps={{ type: 'number' }}
                        style={{ mt: 0, width: '50px' }}
                      />
                      <Typography sx={{ display: 'flex' }}>Minutes</Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={nextActionData.enter_kill_checked}
                        onChange={(event) => onChangeNextActionCheckbox('enter_kill_checked', event)}
                      />
                      <Typography sx={{ display: 'flex' }}>Kill After &nbsp;&nbsp;</Typography>
                    </Box>
                    <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                      <TextField
                        value={nextActionData.enter_kill_miutes || ''}
                        onChange={(event) => setNextActionData({ ...nextActionData, enter_kill_miutes: event.target.value })}
                        label={``}
                        variant="filled"
                        inputProps={{ type: 'number' }}
                        style={{ mt: 0, width: '50px' }}
                      />
                      <Typography sx={{ display: 'flex' }}>Minutes</Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              <Box>
                <Divider sx={{ mt: 2, mb: 2, borderBottomWidth: 4, bgcolor: '#aaaaaa' }} />
              </Box>

              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Box sx={{
                    display: 'flex',
                  }}>
                    <Checkbox
                      checked={leaveEmailNotify}
                      onChange={(event) => setLeaveEmailNotify(event.target.checked)}
                    />
                    <TextField
                      fullWidth
                      value={item.notify_email_leave}
                      onChange={(event) => setItem({ ...item, notify_email_leave: event.target.value })}
                      label={`Email address to notify if car leaves fence:`}
                      variant="filled"
                      inputProps={{ type: 'email' }}
                      margin="normal"
                    />
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Stack justifyContent={`flex-start`} alignItems={`center`} direction={`row`} spacing={2}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={leavePushNotify}
                        onChange={(event) => setLeavePushNotify(event.target.checked)}
                      />
                      <Typography sx={{ display: 'flex' }}>Push</Typography>
                    </Box>
                    <Select value={item.leave_push_sound || 'depart'} onChange={(event) => setItem({ ...item, leave_push_sound: event.target.value })} variant="filled">
                      {
                        NOTIFICATION_SOUND_LIST.map((n_item) => {
                          return (
                            <MenuItem key={n_item.value} value={n_item.value}>{n_item.name}</MenuItem>
                          )
                        })
                      }
                    </Select>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    value={item.leave_subject || GEOFENCE_DEFAULT_LEAVE_SUBJECT}
                    onChange={(event) => setItem({ ...item, leave_subject: event.target.value })}
                    label={`Subject`}
                    variant="filled"
                    inputProps={{ type: 'text' }}
                    margin="normal"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={nextActionData.leave_lock_checked}
                        onChange={(event) => onChangeNextActionCheckbox('leave_lock_checked', event)}
                      />
                      <Typography sx={{ display: 'flex' }}>Lock After</Typography>
                    </Box>
                    <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                      <TextField
                        value={nextActionData.leave_lock_miutes || ''}
                        onChange={(event) => setNextActionData({ ...nextActionData, leave_lock_miutes: event.target.value })}
                        label={``}
                        variant="filled"
                        inputProps={{ type: 'number' }}
                        style={{ mt: 0, width: '50px' }}
                      />
                      <Typography sx={{ display: 'flex' }}>Minutes</Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={nextActionData.leave_horn_checked}
                        onChange={(event) => onChangeNextActionCheckbox('leave_horn_checked', event)}
                      />
                      <Typography sx={{ display: 'flex' }}>Horn After</Typography>
                    </Box>
                    <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                      <TextField
                        value={nextActionData.leave_horn_miutes || ''}
                        onChange={(event) => setNextActionData({ ...nextActionData, leave_horn_miutes: event.target.value })}
                        label={``}
                        variant="filled"
                        inputProps={{ type: 'number' }}
                        style={{ mt: 0, width: '50px' }}
                      />
                      <Typography sx={{ display: 'flex' }}>Minutes</Typography>
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12}>
                  <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={nextActionData.leave_kill_checked}
                        onChange={(event) => onChangeNextActionCheckbox('leave_kill_checked', event)}
                      />
                      <Typography sx={{ display: 'flex' }}>Kill After &nbsp;&nbsp;</Typography>
                    </Box>
                    <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                      <TextField
                        value={nextActionData.leave_kill_miutes || ''}
                        onChange={(event) => setNextActionData({ ...nextActionData, leave_kill_miutes: event.target.value })}
                        label={``}
                        variant="filled"
                        inputProps={{ type: 'number' }}
                        style={{ mt: 0, width: '50px' }}
                      />
                      <Typography sx={{ display: 'flex' }}>Minutes</Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}

      <>
        <ConfirmDialog
          open={showConfirmModal}
          setOpen={setShowConfirmModal}
          title={APP_NAME}
          content={confirmText}
          textYes={`Agree`}
          textNo={`Cancel`}
          onClickYes={() => onClickAgreeConfirm()}
          onClickNo={() => onClickCancelConfirm()}
        />
      </>
    </EditItemView>
  );
};

export default GeofencePage;
